// extracted by mini-css-extract-plugin
export var entityChip = "_sk-0";
export var entityChipMissing = "_sk-1";